<template>
	<c-dialog ref="dialog" width="500" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="数据权限" required>
				<c-radio-group name="data_scope" :options="dataScopeDic"></c-radio-group>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		computed: {
			// 获取dictName选项数据
			...mapState(['dataScopeDic']),
		},

		methods: {
			/*********打开编辑框，初始化**********/
			open(data) {
				this.$refs.form.clear();
				this.$refs.form.set({
					id: data.id,
					data_scope: data.data_scope || 1
				});
				//填充form表单
				this.$refs.dialog.open({
					title: "【"+data.user_realname+"】数据权限配置"
				});
			},

			/*******创建、编辑提交处理方法********/
			editHandle(stop, next) {
				stop();
				this.$refs.form.submit({
					url: '/sys_user/update_data_scope',
					rule: {
						data_scope: '请选择数据权限范围'
					},
					success: (data, res) => {
						next();
						this.$message({
							message: '数据权限配置成功',  // 提示内容,
							type: 'success'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
